function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.24821 2.5044H9.31136C9.46201 2.5044 9.58542 2.38143 9.58542 2.23046V0H3.97363V2.23046C3.97363 2.38143 4.09671 2.5044 4.24821 2.5044Z",
  fill: "#999FA3"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.3464 3.41044L10.4891 0.541112V2.23043C10.4891 2.88007 9.9605 3.40867 9.31085 3.40867H4.24771C3.59792 3.40867 3.06947 2.88007 3.06947 2.23043V0H1.24414C0.55699 0 0 0.557101 0 1.24378V12.3145C0 13.0011 0.55699 13.5583 1.24414 13.5583H12.3143C13.0011 13.5583 13.5581 13.0012 13.5581 12.3145V3.92288C13.5581 3.73044 13.4819 3.54629 13.3464 3.41044ZM11.449 10.7053C11.449 11.1059 11.1241 11.4313 10.7226 11.4313H2.83505C2.43392 11.4313 2.1091 11.1059 2.1091 10.7053V6.92012C2.1091 6.51958 2.43392 6.19431 2.83505 6.19431H10.7226C11.1241 6.19431 11.449 6.51963 11.449 6.92012V10.7053Z",
  fill: "#999FA3"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.89523 7.3595H3.66225C3.41221 7.3595 3.20996 7.56138 3.20996 7.8114C3.20996 8.06141 3.41221 8.26329 3.66225 8.26329H9.89525C10.1447 8.26329 10.3471 8.06141 10.3471 7.8114C10.3471 7.56138 10.1448 7.3595 9.89523 7.3595Z",
  fill: "#999FA3"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.99154 9.16748H4.56616C4.3165 9.16748 4.11426 9.36936 4.11426 9.61938C4.11426 9.86889 4.3165 10.0713 4.56616 10.0713H8.99151C9.24117 10.0713 9.44344 9.86889 9.44344 9.61938C9.44347 9.36936 9.2412 9.16748 8.99154 9.16748Z",
  fill: "#999FA3"
});

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.72b7a598.svg";
export { ForwardRef as ReactComponent };